import { Component, Injector, Optional } from '@angular/core';

import { FactuurService } from 'src/app/core/service/factuur.service';
import { Factuur } from 'src/app/core/dto/factuur';
import { Filter, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType, AuthorizationScheme, AuthorizationSchemeService } from '@mango/core';
import { Router } from '@angular/router';
import { WithoutValidationMessage } from 'src/app/core/utils/string';
import { environment } from 'src/environments/environment';
import { TabService } from 'src/app/core/service/tab.service';
import { LoadingDialogComponent } from 'src/app/shared/components/loading-dialog/loading-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'c-i-j-borculo-factuur-exporteren-collection',
    templateUrl: './factuur-collection.component.html'/*,
    styleUrls: ['./factuur-collection.component.css'] */
})
export class FactuurExporterenCollectionComponent extends PagedCollectionComponent<Factuur> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Factuur>([
      { colDef: 'foutmeldingExact', prop: x => x.foutmeldingExact},
      { colDef: 'factuur', prop: x => x.id, searchable: SearchableType.String },
      { colDef: 'nummer', prop: x => x.oldID, searchable: SearchableType.String },
      { colDef: 'groep', prop: x => x.pakbon.project.projectgroep.afdeling, searchable: SearchableType.String },
      { colDef: 'factuurDatum', prop: x => x.factuurDatum, searchable: SearchableType.Date },		
      { colDef: 'pakbon', prop: x => x.pakbon.pakbonnummer, searchable: SearchableType.String },
      { colDef: 'project', prop: x => x.pakbon.project.code, searchable: SearchableType.String },
		  { colDef: 'naam1', prop: x => x.naam1, searchable: SearchableType.String },
		  { colDef: 'plaats', prop: x => x.plaats, searchable: SearchableType.String },
		  { colDef: 'eMail', prop: x => x.eMail, searchable: SearchableType.String },
		  { colDef: 'omschrijving1', prop: x => x.omschrijving1, searchable: SearchableType.String },
      { colDef: 'totaalbedrag', prop: x => x.totaalbedrag, searchable: SearchableType.Number },
      { colDef: 'totaalKalibratieMetKorting', prop: x => x.totaalKalibratieMetKorting, searchable: SearchableType.Number },
      { colDef: 'totaalArtikelen', prop: x => x.totaalArtikelen, searchable: SearchableType.Number },
      { colDef: 'totaalbedrag_icon', prop: x => x.totaalbedrag,  searchable: SearchableType.Number },
      { colDef: 'isProForma', prop: x => x.isProForma, searchable: SearchableType.Boolean },
      { colDef: 'goedgekeurdOp', prop: x => x.goedgekeurdOp, searchable: SearchableType.Date },
      { colDef: 'mailDatum', prop: x => x.mailDatum, searchable: SearchableType.Date },
        
    ]);
    
    displayedColumns = this.columnDefinitions.map(x => x.colDef);
    myScheme: AuthorizationScheme;

    constructor(public service: FactuurService, private authService: AuthorizationSchemeService, private tabService: TabService, private dialog: MatDialog, @Optional() protected filter: Filter<Factuur>, injector: Injector, private route:Router) {
        super('/factuur/exporteren', injector, Factuur);

        this.myScheme = this.authService.getMyScheme();
		
        // Goedgekeurd maar nog niet naar Exact
        this.filter.add(this.filterBuilder.notEqual(x => x.goedgekeurdOp, null),true);
        this.filter.add(this.filterBuilder.equal(x => x.naarExactOp, null),true);        

        this.orderBy = [-2];

        this.filter.onGetChipLabel(x => x.id, () => 'Factuur');
        this.filter.onGetChipLabel(x => x.oldID, () => 'Nummer');		
        this.filter.onGetChipLabel(x => x.factuurDatum, () => 'Factuurdatum');		
        this.filter.onGetChipLabel(x => x.pakbon.pakbonnummer, () => 'Pakbonnummer');
        this.filter.onGetChipLabel(x => x.pakbon.project.code, () => 'Project');
        this.filter.onGetChipLabel(x => x.naam1, () => 'Naam');
        this.filter.onGetChipLabel(x => x.plaats, () => 'Plaats');		
        this.filter.onGetChipLabel(x => x.eMail, () => 'Email');
        this.filter.onGetChipLabel(x => x.omschrijving1, () => 'Omschrijving');
        this.filter.onGetChipLabel(x => x.totaalbedrag, () => 'Totaalbedrag');
        this.filter.onGetChipLabel(x => x.isProForma, () => 'ProForma');
        this.filter.onGetChipLabel(x => x.goedgekeurdOp, () => 'Goedgekeurd');		
        this.filter.onGetChipLabel(x => x.mailDatum, () => 'Verzonden');        
    }

    ngOnInit() {
      super.ngOnInit();
      
      this.buildCustomActions(config => config.add({
          icon: 'download',
          name: "Exporteren Excel",
          pin: false,
          show: () => this.authScheme.canDo("CIJBorculo.Logic.ExporteerFactuurRequest"),
          fn: () => {
                  this.service.exporteerFacturenExcel(this.filter).toPromise().then(
            (value) => {
              var blob = this.service.ConvertResponseToBlob(value);
                          var url = window.URL.createObjectURL(blob);
                          let anchor = document.createElement('a');
                          anchor.href = url;
                          if (value.fileName) {
                              anchor.setAttribute('download', value.fileName);
                          }
                          anchor.target = '_blank';
                          anchor.click();
                });                
                }
      }));

      this.buildCustomActions(config => {
          this.addSimpleMultiSelectAction({
              config,
              show: () => this.canDoExact(),
              fn: (items: Factuur[]) => {
                this.ExportFactuurExact(items);                        
                return true;
              },
              icon: 'explicit',
              title: 'Exporteren Exact',
              isSelectable: item => (item.goedgekeurdOp !== null && item.goedgekeurdOp !== undefined && (item.naarExactOp == null && item.naarExactOp == undefined))
          })
      });

      // Inloggen  Exact
      this.buildCustomActions(config => config.add({
        icon: "login",
        name: "Inloggen Exact",
        fn: () => {
          this.Authenticate();
        },
        pin: false,
        pinShowTitle:false,
        show: () => this.canDoExact()
      }));
      
  }

  displayColumn(colDef: ColumnDefinition, ix: number) {
		// Hide columns that are already filtered on
		if(colDef.colDef == 'totaalbedrag_icon') { return false; }

		return super.displayColumn(colDef, ix);
	}

  Authenticate() {
    let query: string = environment.exactUrl;

    this.openTab(query);
  }
    
  openTab(url: string) {
        this.tabService.openTab(url, '_blank');
    }
  
  closeTab() {
      this.tabService.closeTab();
  }
  
  canDelete() {
      return false;
  }

  canDoExact() {
    return this.myScheme.canDo('CIJBorculo.Logic.ExactRequest') && this.myScheme.canDo("CIJBorculo.Logic.FactuurExportExactRequest") && this.myScheme.canDo("CIJBorculo.Logic.ExporteerFactuurExactRequest")
  }

  async ExportFactuurExact (items: Factuur[])
  {
      let loadDialogRef = null;

      loadDialogRef = this.dialog.open(LoadingDialogComponent, {
        data: {
          title: "Een moment geduld", 
          label: "De facturen worden geëxporteerd naar Exact..."
        },
        width: '300px',
        disableClose: true, 
        closeOnNavigation: false,
    });

    await this.service.exporteerFacturen(items).toPromise().then(
        (value) => { 
            loadDialogRef.close();

            if (value.successful) {                
                this.dialogs.snack("De facturen zijn geëxporteerd!");
            } else {
                this.dialogs.snackAction(value.message, ()=>{},"ok", 3000);
            }

            // Altijd Refresh/Reload!
            this.router.navigateByUrl('/', {skipLocationChange: true}).then(()=>
                this.route.navigateByUrl('/factuur/exporteren/50/0/-2'));


        }).catch((value) =>{
          loadDialogRef.close();
          this.dialogs.snackError(WithoutValidationMessage(value.error.message))
        }
    );    
  }

  

  
}